import { Directive } from "@angular/core";
import {
	Input,
	Output,
	OnChanges,
	EventEmitter,
	ElementRef,
	HostListener,
	ChangeDetectorRef,
} from "@angular/core";
@Directive({
	selector: "[appBackgroundImage]",
})
export class BackgroundImageDirective implements OnChanges {
	@Input() imageUrl?: string;
	@Input() width?: string;
	@Input() height?: string;
	@Input() bgColor?: string;
	@Output() orientaionChange?: EventEmitter<any> = new EventEmitter<any>();

	private el: HTMLElement;
	constructor(
		private elementRef: ElementRef,
		private changeDetector: ChangeDetectorRef
	) {
		console.log("BackgroundImageDirective");
		this.el = elementRef.nativeElement;
	}
	ngAfterViewInit() {
		if (!this.el) return;
		console.log("this.imageUrl", this.imageUrl);
		this.el.style.backgroundImage = "url(" + this.imageUrl + ")";
		this.el.style.backgroundRepeat = "no-repeat";
		//this.el.style.backgroundRepeat = 'no-repeat';
		//this.el.style.backgroundColor = (this.bgColor)?this.bgColor:"";
		// this.el.style.backgroundSize = 'cover';
		//this.el.style.width = (this.width)?this.width:"100%";
		//this.el.style.height = (this.width)?this.height:"100%";
	}

	@HostListener("change") ngOnChanges() {
		this.el.style.backgroundImage = "url(" + this.imageUrl + ")";
		this.el.style.backgroundRepeat = "no-repeat";
		this.el.style.backgroundSize = "cover";
		this.changeDetector.markForCheck();
	}
}
